import React from 'react';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import UserAddress from './UseUserAddress';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { FiPlus } from 'react-icons/fi';
import Navigation from '../../../layout/Navigation/Navigation';
import { Link } from 'react-router-dom';

const UserAddressPage: React.FC = () => {
  const { states, navigate } = UserAddress();

  return (
    <div className='flex items-center justify-center bg-white px-2 sm:px-2 md:px-6 lg:px-6 py-3 sm:py-3 md:py-12 lg:py-12'>
      <div className='bg-white w-full max-w-7xl rounded-xl sm:rounded-xl md:rounded-xl xl:rounded-xl shadow-none overflow-hidden pb-6 sm:pb-6 md:pb-0 lg:pb-0 flex flex-col lg:flex-row'>
        {/* Global Navigation */}
        <Navigation />

        {/* Mobile view */}
        <div className='block sm:block md:hidden lg:hidden'>
          <div className='flex flex-col bg-white font-poppins'>
            <div className='block sm:hidden px-4 pb-4 text-lg font-semibold flex items-center'>
              <FaArrowLeftLong onClick={() => navigate(-1)} className='mr-3' />
              Address
            </div>
            <div className='block sm:hidden px-4'>
              <Link to='/user/create-address'>
                <div className='border border-[#C12E2A] text-[#C12E2A] font-semibold px-4 py-2 rounded-lg flex items-center text-sm'>
                  <FaPlus className='mr-2' />
                  Add New Address
                </div>
              </Link>
            </div>
            {/* Shipping Addresses */}
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 px-4 sm:px-6 md:px-6 lg:px-6 mt-4 '>
              {states.shippingAddresses.map((address: any, index: number) => (
                <div key={`shipping-${index}`} className='border rounded-xl p-4 bg-white relative drop-shadow-xl mb-4'>
                  <div className='flex justify-between items-center border-b pb-2 mb-2'>
                    <div className='flex'>
                      {address.is_shipping_address === 1 && (
                        <input
                          type='checkbox'
                          checked={true}
                          readOnly
                          className='mr-2 min-h-5 min-w-6 accent-green-700'
                        />
                      )}
                      <h2 className='text-sm text-[#999999] uppercase'>SHIPPING ADDRESS</h2>
                    </div>
                    <div className='flex gap-2'>
                      <Link to={`/user/edit-address/${address.name}`}>
                        <FaEdit className='text-[#4A2D1A] cursor-pointer' />
                      </Link>
                      {/* <FaTrash className="text-[#4A2D1A] cursor-pointer" /> */}
                    </div>
                  </div>

                  <div className='text-[#1A1A1A] leading-relaxed'>
                    <p className='text-base'>{address.contacts?.[0]?.name || 'N/A'}</p>
                    <p className='text-[#999999] text-sm'>
                      {address.address_line1}, {address.address_line2}, {address.city}, {address.state}-
                      {address.pincode}
                    </p>

                    <p className='text-xs mt-3 text-[#999999]'>Email:</p>
                    <p className='text-[#1A1A1A] text-sm'>{address.contacts?.[0]?.email_id || '-'}</p>

                    <p className='text-xs mt-3 text-[#999999]'>Phone:</p>
                    <p className='text-[#1A1A1A] text-sm'>{address.contacts?.[0]?.mobile_no || '-'}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Desktop veiw */}
        <div className='hidden sm:hidden md:block lg:block flex-1 bg-white rounded-xl shadow-md ml-0 lg:ml-6 mt-4 sm:mt-4 md:mt-0 lg:mt-0 border'>
          <div className='flex justify-between items-center px-6 py-2 pb-4 border-b'>
            <h1 className='text-xl text-[#1A1A1A] font-medium font-poppins'>Address</h1>
            <Link to='/user/create-address'>
              <button className='flex items-center bg-white hover:bg-[#4A2D1A] text-base text-[#4A2D1A] hover:text-white px-4 py-1 font-medium rounded-lg font-poppins'>
                <FiPlus className='text-lg' /> &nbsp;&nbsp;Add New Address
              </button>
            </Link>
          </div>
          {/* SHIPPING ADDRESSES */}
          <div>
            <div className='p-4 border-b flex justify-between items-center'>
              <h2 className='text-base text-[#999999] font-poppins'>SHIPPING ADDRESS</h2>
            </div>

            {states.shippingAddresses.length > 0 ? (
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 p-4'>
                {states.shippingAddresses.map((address, idx) => (
                  <div key={idx} className='p-4 border rounded-xl'>
                    <div className='flex justify-between items-center mb-2'>
                      {address.is_shipping_address === 1 && (
                        <input
                          type='checkbox'
                          checked={true}
                          readOnly
                          className='mr-0 min-h-5 min-w-6 accent-green-700'
                        />
                      )}
                      <p className='text-base font-semibold'>{address.contacts?.[0]?.name || 'N/A'}</p>
                      <div className='flex gap-3'>
                        <Link to={`/user/edit-address/${address.name}`}>
                          <FaEdit className='text-[#4A2D1A] cursor-pointer' />
                        </Link>
                      </div>
                    </div>

                    <p className='text-sm text-[#999999]'>
                      {address.address_line1}, {address.address_line2}
                    </p>
                    <p className='text-sm text-[#999999]'>
                      {address.city}, {address.state} - {address.pincode}
                    </p>
                    <p className='text-sm text-[#999999]'>{address.country}</p>

                    <p className='text-xs mt-2 text-[#999999]'>EMAIL</p>
                    <p className='text-base'>{address.contacts[0]?.email_id || 'N/A'}</p>

                    <p className='text-xs mt-2 text-[#999999]'>PHONE</p>
                    <p className='text-base'>{address.contacts[0]?.mobile_no || 'N/A'}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className='p-4 text-sm text-gray-500'>No shipping address found</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAddressPage;
